import { OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:4200';

export const mg3pOidcConfig: OpenIdConfiguration = {
  authority: environment.oidc.authority,
  clientId: environment.oidc.clientId,
  redirectUrl: `${origin}/inicio`,
  postLogoutRedirectUri: origin,
  scope: environment.oidc.scope,
  responseType: 'code',
  silentRenew: true,
  useRefreshToken: true,
  renewTimeBeforeTokenExpiresInSeconds: 30,
};
